import {useCallback} from 'react';
import {OnChangeFieldValue} from '../../field/FieldValue';

export const useOnClear = (onChange: OnChangeFieldValue, fieldId: string) => {
  return useCallback(() => onChange({[fieldId]: null}), [onChange, fieldId]);
};
